module.exports = __webpack_public_path__ + "static/media/table.56ace1d3.svg";